define('core/mixins/withAlert',[
    'underscore',

    'core/views/AlertView',
], function (
    _,

    AlertView
) {
    'use strict';

    /**
     * @typedef {('error'|'info'|'success'|'warn')} AlertStyle
     */

    var mixin = {
        /**
         * Render an alert box in above the current view
         *
         * @param {string} message - the message to display (required)
         * @param {Object} [options] - options
         * @param {boolean} [options.safe] - don't HTML-escape message contents
         * @param {string} [options.target] - a selector for an element to place the alert within
         * @param {AlertStyle} [options.type] - the style of alert to use
         * @returns {AlertView}
         */
        alert: function (message, options) {
            if (!_.isObject(options))
                options = {};

            var alertSelector = options.target || this._alertSelector;

            // Only one alert box at one time
            this.dismissAlert();

            var alert = this._alert = new AlertView(_.extend({
                message: message,
            }, options));

            this.listenToOnce(this._alert, 'dismiss', function () {
                this._alert = null;
            });

            alert.render();

            // If a selector is given, insert the alert at that
            // location. Otherwise insert before the element.
            if (alertSelector) {

                var alertContianerEl = this.$el.find(alertSelector);

                /* TODO: @taylangocmen when you enable and disable comments the open/close state and alert has not
                    been updated and fetched in the BE, do an optimistic rendering for those in that case */

                // Sometimes when alert is called threadView and alertContainerEl is not rendered yet
                // in that case listen to threadView to render then try alert again
                if (alertContianerEl.length)
                    alertContianerEl.prepend(alert.el);
                else
                    this.listenToOnce(this, 'threadView:render', function () { return this.alert(message, options); });

            } else if (this.el.parentNode) {
                this.el.parentNode.insertBefore(alert.el, this.el);
            }

            return alert;
        },

        /**
         * Dismiss any active alert.
         *
         * @param {function(AlertView): *} [filter] -
         *     if provided, the alert will only be dismissed if the function returns truthy
         */
        dismissAlert: function (filter) {
            if (!this._alert)
                return;

            if (filter && !filter(this._alert))
                return;

            this.stopListening(this._alert);
            this._alert.dismiss();
            this._alert = null;
        },

        /**
         * Returns the current alert, if any.
         *
         * @returns {?AlertView}
         */
        getAlert: function () {
            return this._alert || null;
        },

        /**
         * Specify a selector string that designates where the alert should be prepended.
         * e.g. this.setAlertSelector('.someClass');
         *
         * @param {string} selector - The selector string
         */
        setAlertSelector: function (selector) {
            this._alertSelector = selector;
        },
    };

    var withAlert = function () {
        return _.extend(this, mixin);
    };

    return withAlert;
});

